<script lang="ts">
	import { onMount } from 'svelte';
	import { addToCart, getSubscriptionData } from '$lib/stores/shopStore';
	import { page } from '$app/stores';

	import Media from '$lib/components/media/Media.svelte';
	import Text from '$lib/components/Text.svelte';
	import Dropdown from '$lib/components/inputs/Dropdown.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import { getVariantName } from '$lib/util/ecom/util';
	import { getText } from '$lib/util/translations';
	import QuantitySelector from '$lib/components/ecom/QuantitySelector.svelte';
	import { formatPrice } from '$lib/util/ecom/format';
	import { injectDiscounts } from '$lib/util/ecom/discounts';

	export let media;
	export let title;
	export let special = false;
	let loaded = false;

	let sellingPlans: any[] = [];
	let subscriptionProducts: any[] = [];
	let specialProduct: any;

	let selectedProductIdx: number = -1;
	let selectedVariantIdx: number = -1;
	let selectedSellingPlanIdx: number = -1;
	let selectedQuantity: number = 1;

	onMount(async () => {
		const data = await getSubscriptionData(
			$page.data.location,
			$page.params.lang,
			special ? 'Special Edition Subscription' : 'Coffee Subscription'
		).catch((e) => console.error(e));
		loaded = true;

		if (!data) {
			return;
		}

		sellingPlans = data?.sellingPlans ?? [];
		subscriptionProducts = data?.subscriptionProducts ?? [];

		//Filter
		let products = [];

		for (const p of subscriptionProducts) {
			/*
			for (const collection of p.collections.edges) {
				if (collection.node.handle === 'speciality-coffee') {
					isSpecialProduct = true;
				}
			}
			*/

			products.push(p);

			if (special) {
				break;
			}
		}

		if (special) {
			selectedProductIdx = 0;
			selectedVariantIdx = 0;
		}

		subscriptionProducts = products;

		loaded = true;
	});

	$: selectedProduct = subscriptionProducts[selectedProductIdx];

	function previewImage() {
		const product = selectedProduct;
		if (!product.variants.edges[selectedVariantIdx]?.image?.url) {
			return product && product.media && product.media.edges.length > 0
				? product.media.edges[0].node.previewImage.url
				: '';
		}

		return product.variants.edges[selectedVariantIdx]?.image?.url;
	}

	function addSubscription() {
		if (selectedProductIdx >= 0 && selectedVariantIdx >= 0 && selectedSellingPlanIdx >= 0) {
			const variantId =
				subscriptionProducts[selectedProductIdx].variants.edges[selectedVariantIdx]?.node?.id;

			addToCart(
				variantId,
				selectedQuantity,
				discountedPrice?.amount,
				discountedPrice?.currentyCode,
				subscriptionProducts[selectedProductIdx].title,
				previewImage(),
				'gid://shopify/SellingPlan/' + sellingPlans[selectedSellingPlanIdx].selling_plan_id
			);
		}
	}

	$: selectedSellingPlan = sellingPlans[selectedSellingPlanIdx];

	$: basePrice = selectedProduct?.variants.edges[selectedVariantIdx]?.node?.priceV2;
	$: discount =
		selectedSellingPlan?.pricing_policy_fixed_adjustment_type === 'PERCENTAGE'
			? Number(selectedSellingPlan?.pricing_policy_fixed_adjustment_value) / 100
			: 0;
	$: discountedPrice = {
		...basePrice,
		amount: Math.round(basePrice?.amount * (1 - discount) * 100) / 100
	};
	$: showPrice = selectedProductIdx >= 0 && selectedVariantIdx >= 0 && selectedSellingPlanIdx >= 0;
</script>

<div class="subscription-card" class:special>
	<!-- {selectedProduct} -->
	<div class="image">
		<Media {...media} fit="cover" transform="l" />
	</div>
	{#if subscriptionProducts.length > 0}
		<div class="content">
			<div class="subscription-title">
				{special ? subscriptionProducts?.[0]?.title ?? '' : title}
			</div>
			{#if special}
				<div class="speciality-title">
					<Text key="speciality_title" />
				</div>
			{/if}
			<div class="subscripion-settings">
				{#if !special}
					<div class="option">
						<span>1. <Text key="choose_your_coffee" /></span>
						<Dropdown bind:value={selectedProductIdx} type="small">
							<option selected value={-1} disabled
								>{getText($page.data.globalTexts, 'ecom_which_product').text}</option
							>
							{#each subscriptionProducts as product, idx}
								<option value={idx}>{product?.title}</option>
							{/each}
						</Dropdown>
					</div>
				{/if}
				{#if !special}
					<div class="option">
						<span>{special ? '1.' : '2.'} <Text key="package_size" /></span>
						<Dropdown bind:value={selectedVariantIdx} type="small">
							<option selected value={-1} disabled
								>{getText($page.data.globalTexts, 'ecom_which_size').text}</option
							>
							{#if selectedProductIdx >= 0}
								{#each subscriptionProducts[selectedProductIdx].variants.edges ?? [] as variant, idx}
									<option value={idx}>{getVariantName(variant.node)}</option>
								{/each}
							{/if}
						</Dropdown>
					</div>
				{/if}
				<div class="option">
					<span>{special ? '1.' : '3.'} <Text key="interval" /></span>
					<Dropdown bind:value={selectedSellingPlanIdx} type="small">
						<option selected value={-1} disabled
							>{getText($page.data.globalTexts, 'ecom_which_interval').text}</option
						>
						{#each sellingPlans as sellingPlan, idx}
							<option value={idx}>
								{sellingPlan?.name}
								<!-- {sellingPlan.delivery_interval_count}
									{getText(
										$page.data.globalTexts,
										'ecom_' +
											sellingPlan.delivery_interval +
											(sellingPlan.delivery_interval_count > 1 ? 's' : '')
									).text} -->
							</option>
						{/each}
					</Dropdown>
				</div>
				<div class="option-row">
					<div class="option">
						<span>{special ? '2.' : '4.'} <Text key="amount" /></span>
						<div class="quanitity-selector" class:special>
							<QuantitySelector bind:value={selectedQuantity} max={10} />
						</div>
					</div>
					{#if showPrice}
						<div class="price-wrapper">
							<div class="price">
								{formatPrice(
									injectDiscounts(discountedPrice?.amount * selectedQuantity),
									discountedPrice?.currencyCode,
									$page.params.lang
								)}
							</div>
							<div class="compare-price">
								{formatPrice(
									injectDiscounts(basePrice?.amount * selectedQuantity),
									basePrice?.currencyCode,
									$page.params.lang
								)}
							</div>
						</div>
					{/if}
				</div>
			</div>
		</div>
		<div class="subscribe-button">
			<Button
				textKey="subscribe_now"
				on:click={addSubscription}
				style="dark"
				iconKey="icon-arrow-right-long"
			/>
		</div>
	{:else if loaded}
		<div class="content no-product">
			<div class="subscription-title">
				{special ? subscriptionProducts?.[0]?.title ?? '' : title}
			</div>
			{#if special}
				<div class="speciality-title">
					<Text key="speciality_title" />
				</div>
			{/if}
			<div class="no-product-message">
				<Text key="subscription_no_product" />
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	.option-row {
		display: flex;
		justify-content: space-between;
	}

	.no-product {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		@include font(text-sm);
	}

	.price-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		text-align: right;
		text-wrap: nowrap;
		flex: 1;

		.price {
			@include font(h4);
		}
		.compare-price {
			@include font(text);
			text-decoration: line-through;
		}
	}

	.subscription-card {
		padding: v(content-gap-sm);
		width: 100%;
		height: 100%;
		&:first-child {
			background: color(white);
		}
		&:nth-child(3) {
			margin-top: v(content-gap-2xl);
			background: color(yellow_02);
			@include media(phone) {
				margin-top: 0;
			}
		}
		@include media(tablet) {
			// margin-bottom: v(content-gap-xl);
			&.special {
				background: color(yellow_02);
			}
		}

		&.special {
			:global(.dropdown) {
				:global(select) {
					background: color(white) !important;
				}
			}
		}
	}

	.subscription-title {
		@include font(h4);
	}

	.content {
		display: flex;
		flex-direction: column;
		gap: v(content-gap-sm);
		padding: v(content-padding-sm) 0;
	}

	.subscripion-settings {
		display: flex;
		flex-direction: column;
		gap: v(content-gap);
		.option {
			display: flex;
			flex-direction: column;
			gap: v(content-gap-xs);
			@include font(h6);
			width: 100%;
			align-items: start;
			span {
				display: flex;
				width: 100%;
				white-space: nowrap;
				gap: v(content-gap-2xs);
			}
		}
		:global(.dropdown) {
			max-width: 100%;
			padding: 0 !important;
			height: 2rem !important;
		}

		&.special {
			:global(.dropdown) {
				:global(select) {
					background: color(white) !important;
				}
			}
		}
	}
	.subscribe-button {
		:global(button) {
			width: 100%;
			display: flex;
			justify-content: center;
		}
	}

	.subscriptions-mobile {
		display: none;
		@include media(phone) {
			display: block;
			position: relative;
		}
		:global(.swiper-pagination) {
			position: absolute !important;
			bottom: 0;
		}
	}

	.quanitity-selector {
		:global(.quantitiy-selector) {
			background-color: color(grey_02) !important;
			border-radius: 4px !important;
			border: 0 !important;
			height: 32px !important;
		}
		:global(.textfield) {
			@include font(text-sm);
		}

		&.special :global(.quantitiy-selector) {
			background-color: color(white) !important;
		}

		:global(button) {
			display: inline-flex;
			align-items: center;
			justify-content: center;
		}

		:global(.svg) {
			flex-shrink: 0;
		}

		:global(select) {
			@include font(text-sm);
		}
	}
	.speciality-title {
		@include font(h6);
	}
</style>
